import View from "./view";
import CreatePresenter from "./create.presenter";
import EditPresenter from "./edit.presenter";
import { ConnectComponent2 } from "util";

const states = [
  {
    name: "app.registration.discount.create",
    url: "/novo",
    views: {
      "content@app": ConnectComponent2(View, CreatePresenter)
    }
  },
  {
    name: "app.registration.discount.edit",
    url: "/:discountUuid/editar",
    views: {
      "content@app": ConnectComponent2(View, EditPresenter)
    }
  }
];

export { states };



// WEBPACK FOOTER //
// ./src/components/app/registration/discount/form/index.js